module.exports = __webpack_public_path__ + "media/reports/pablita-uploading 1-6f0df8fc.svg";